var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayImage)?_c('img',{staticClass:"file-image",attrs:{"src":_vm.source}}):_c('file-form',{attrs:{"value":_vm.value,"filter":_vm.filter,"is-hover":_vm.isHover}})
}
var staticRenderFns = []

export { render, staticRenderFns }